import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Header {
    constructor (mobileBreakpoint) {
        // Settings
        this.speed = 200;
        this.mobileBreakpoint = mobileBreakpoint;

        // General
        this.$document = $(document);
        this.$window = $(window);
        this.$header = $('#header');

        // Search
        this.$searchForm = $('.js-search-form');
        this.$searchField = $('.js-search-input');
        this.$searchToggleButton = $('.js-search-toggle');
        this.$searchMobileButton = $('.js-search-mobile-btn');

        // Burger Menu
        this.$burgerButton = $('.js-burger-btn');
        this.$burgerContent = $('.js-burger-content');
        this.$subMenus = $('.js-sub-menu');

        // Mobile Menu
        this.$chevrons = $('.js-menu-chevron');
        this.$chevrons.attr('aria-expanded', 'false');

        // Themes Menu
        this.$themesButton = $('.js-themes-btn');
        this.$themesContent = $('.js-themes-content');

        // Profile Menu
        this.$profileButton = $('.js-profile-btn');
        this.$profileContent = $('.js-profile-content');

        // Search Events
        this.$searchToggleButton.on('click', $.proxy(this.toggleSearch, this));

        // Close search on doc click
        this.$document.on('click', $.proxy(this.documentClick, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
            }
        });

        // Mobile Events
        this.$burgerButton.on('click', $.proxy(this.toggleBurger, this));
        this.$profileButton.on('click', $.proxy(this.toggleProfile, this));
        this.$themesButton.on('click', $.proxy(this.toggleThemes, this));
        this.$searchMobileButton.on('click', $.proxy(this.toggleSearchMobile, this));

        // Mobile Menu Events
        this.$chevrons.on('click', $.proxy(this.toggleSubMenu, this));

        // Resize Events
        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
                this.destroyScrollbars();
            } else {
                this.addScrollbars();
            }
        }, 300)).on('load', () => {
            if (this.$window.width() <= this.mobileBreakpoint) {
                this.addScrollbars();
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];
    }

    addScrollbars () {
        this.scrollbars.push(new Ps(this.$burgerContent[0]));
    }

    destroyScrollbars () {
        this.scrollbars.forEach((ps) => ps.destroy());
    }

    updateScrollbars () {
        this.scrollbars.forEach((ps) => ps.update());
    }

    documentClick (e) {
        const $elem = $(e.target);

        if (!$elem.closest(this.$header).length) {
            this.closeSearch();
        }
    }

    // Sub Menu (mobile)
    toggleSubMenu (e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');
        $elem.parent().next().slideToggle(this.speed, () => {
            this.updateScrollbars();
        });

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }
    }

    // Burger
    //-----------------------------
    closeBurger () {
        this.$burgerButton.removeClass('is-open');
        this.$burgerContent.fadeOut(this.speed, () => {
            // Close sub-menus
            this.$chevrons.removeClass('is-open');
            this.$subMenus.removeClass('is-open').removeAttr('style');
        });
    }

    toggleBurger () {
        this.$burgerButton.toggleClass('is-open');
        this.$burgerContent.fadeToggle(this.speed, () => {
            this.updateScrollbars();

            if (this.$burgerContent.is(':visible')) {
                this.closeThemes();
                this.closeSearch();
                this.closeProfile();
            }

            this.scrollLock();
        });
    }

    // Themes
    //-----------------------------
    closeThemes () {
        this.$themesButton.removeClass('is-open');
        this.$themesContent.fadeOut(this.speed);
    }

    toggleThemes () {
        this.$themesButton.toggleClass('is-open');
        this.$themesContent.fadeToggle(this.speed, () => {
            if (this.$themesContent.is(':visible')) {
                this.closeBurger();
                this.closeSearch();
                this.closeProfile();
            }

            this.scrollLock();
        });
    }

    // Search
    //-----------------------------
    closeSearch () {
        this.$searchToggleButton.removeClass('is-open');
        this.$searchMobileButton.removeClass('is-open');
        this.$searchForm.fadeOut(this.speed);
    }

    toggleSearch () {
        this.$searchToggleButton.toggleClass('is-open');

        this.$searchForm.fadeToggle(this.speed, () => {
            if (this.$searchField.is(':visible')) {
                this.$searchField.focus();
            }
        });
    }

    toggleSearchMobile () {
        this.$searchMobileButton.toggleClass('is-open');

        this.$searchForm.fadeToggle(this.speed, () => {
            if (this.$searchField.is(':visible')) {
                this.$searchField.focus();

                this.closeBurger();
                this.closeThemes();
                this.closeProfile();
            }

            this.scrollLock();
        });
    }

    // Profile
    //-----------------------------
    closeProfile () {
        this.$profileButton.removeClass('is-open');
        this.$profileContent.fadeOut(this.speed);
    }

    toggleProfile () {
        this.$profileButton.toggleClass('is-open');
        this.$profileContent.fadeToggle(this.speed, () => {
            if (this.$profileContent.is(':visible')) {
                this.closeBurger();
                this.closeThemes();
                this.closeSearch();
            }

            this.scrollLock();
        });
    }

    // Check whether to scroll lock the body
    //-----------------------------
    scrollLock () {
        if (this.$burgerButton.hasClass('is-open')
            || this.$profileButton.hasClass('is-open')
            || this.$themesButton.hasClass('is-open')
            || this.$searchMobileButton.hasClass('is-open')) {
            $('body').addClass('is-scroll-locked');
        } else {
            $('body').removeClass('is-scroll-locked');
        }
    }

    resetEverything () {
        // Close
        this.closeSearch();

        this.$burgerButton.removeClass('is-open');
        this.$burgerContent.removeAttr('style');
        this.$subMenus.removeAttr('style');

        this.$themesButton.removeClass('is-open');
        this.$themesContent.removeAttr('style');

        this.$profileButton.removeClass('is-open');
        this.$profileContent.removeAttr('style');

        this.scrollLock();
    }
}

export default Header;
